/* jshint esversion: 6 */
 
export interface Validators {
    checkArray: (value: string[], field: {validatorText: string}, model: string) => string[];
    checkCheckBox: (value: boolean, field: {validatorText:string}, model:string) => string[];
    checkDate: (value: string|null, field: {validatorText: string}, model: string) => string[];
    checkDoubleInput: (value: string|null, field: {validatorText: string}, model: any) => string[];
    checkDoubleInputVFor: (value: string[]|null, field: {validatorText: string}, model: any) => string[];
    checkEmail2: (value: string, field: {validatorText: string}, model: string) => string[];
    checkEmail: (value: string, field: {validatorText: string}, model: string) => string[];
    checkEmailFurther: (value: string[], field: {validatorText: string}, model: string) => string[];
    checkFileUpload: (value: string[], field: {validatorText: string}, model: any) => string[];
    checkFileUploadDesigned: (value: string, field: {validatorText: string}, model: string) => string[];
    checkFVisitor: (value: string[], field: {validatorText: string}, model: string) => string[];
    checkFurtherJobs: (value: string[], field: {validatorText: string}, model: string) => string[];
    checkInput: (value: string, field: {validatorText: string}, model: string) => string[];
    checkInputFEmail: (value: string, field: {validatorText: string}, model: string) => string[];
    checkMultiCheckBox: (value: string[], field: {validatorText: string}, model: string) => string[];
    checkPLZ: (value: string, field: {validatorText: string}, model: string) => string[];
    checkPassword2: (value: string, field: {validatorText: string}, model: {password: string, password2:string}) => string[];
    checkPassword: (value: string, field: {validatorText: string}, model: string) => string[];
    checkRadio: (value: string, field: {validatorText: string, model:string}, model: string) => string[];
    checkRequestFile:(value:string[], field: {validatorText:string, maxSize:number}, model: string) => string[];
    checkSelect: (value: any, field: {validatorText: string}, model: string) => string[];
    checkSelectJob: (value: string[], field: {validatorText: string}, model: string) => string[];
}

export function validator() {

    const validators: Validators = {
        checkArray: function(value:string[], field: {validatorText:string}, model: string): string[] {
            if (value.length === 0) {
                return [`Bitte wählen Sie mindestens ${field.validatorText} aus.`];
            }
            return [];
        },  
        checkCheckBox: function(value:boolean, field: {validatorText:string}, model: string): string[] {
            if(value === false) {
                return [`Bitte anklicken`];
            }
            return [];
        },             
        checkDate: function(value:string|null, field: {validatorText:string}, model: string): string[] {
            if (!value) {
                return [`Bitte wählen Sie ${field.validatorText} aus.`];
            }
            return [];
        },
        checkDoubleInput: function(value:string|null, field: {validatorText:string}, model: any): string[] {
            if (!model.street) return [`Bitte geben Sie ${field.validatorText} ein.`];
            if (!model.housenumber) return [`Bitte geben Sie ${field.validatorText} ein.`];
            return [];
        },  
        checkDoubleInputVFor: function(value:string[]|null, field: {validatorText:string}, model: any): string[] {
            if (!value) return [`Bitte geben Sie ${field.validatorText} ein.`];
            if (!value[0][0]) return [`Bitte geben Sie ${field.validatorText} ein.`];
            if (!value[0][1]) return [`Bitte geben Sie ${field.validatorText} ein.`];
            return [];
        },  
        checkEmail: function(value:string, field: {validatorText:string}, model: string): string[] {
            if (!value) {
                return [`Bitte geben Sie eine E-Mail-Adresse ein.`];
            }
            const strReg = /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z][a-z]+)|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
            const regex = new RegExp(strReg);
            if (regex.test(value) === false) {
                return [`Bitte geben Sie eine valide E-Mail-Adresse (z.b. test@typonauten.de) ein.`];
            }
            return [];
        },
        checkEmail2: function(value:string, field: {validatorText:string}, model: string): string[] {
            if (!value) {
                return [];
            }
            const strReg = /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z][a-z]+)|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
            const regex = new RegExp(strReg);
            if (regex.test(value) === false) {
                return [`Bitte geben Sie eine valide E-Mail-Adresse (z.b. test@typonauten.de) ein.`];
            }
            return [];
        },
        checkEmailFurther : function (value: string[], field: {validatorText:string}, model: any): string[] {
            if (!value) return [`Bitte geben Sie mindestens eine E-Mail-Adresse ein.`];
            const errorArr:string[] = [];
            const strReg = /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z][a-z]+)|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
            const regex = new RegExp(strReg);
            value.forEach((element:any, index:number) => {
                if (element === '') {
                    errorArr.push(`Bitte geben Sie im ${index+1}. Feld eine E-Mail-Adresse ein.`);
                } else {
                    const trimmedEmail = element.trimStart();
                    if (/\s/.test(trimmedEmail)) {
                        errorArr.push(`In der ${index+1}. E-Mail-Adresse "${trimmedEmail}" befinden sich Leerzeichen`);
                    } else if (!regex.test(trimmedEmail)) {
                        errorArr.push(`Bitte geben Sie bei der  ${index+1}. E-Mail-Adresse "${trimmedEmail}" eine valide E-Mail-Adresse (z.b. test@typonauten.de) ein.`);
                    }
                }
            });
            if (errorArr.length > 0) {
                return errorArr;
            }
            return [];
        },
        checkInputFEmail : function (value: string, field: {validatorText:string}, model: any): string[] {
            if (!value) return [`Bitte geben Sie mindestens eine E-Mail-Adresse ein.`];
            const valueArr = value.split(",");
            const errorArr:string[] = [];
            const strReg = /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z][a-z]+)|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;
            const regex = new RegExp(strReg);
            valueArr.forEach((element:any, index:number) => {
                if (element === '') {
                    errorArr.push(`Bitte geben Sie im ${index+1}. Feld eine E-Mail-Adresse ein.`);
                } else {
                    const trimmedEmail = element.trimStart();
                    if (/\s/.test(trimmedEmail)) {
                        errorArr.push(`In der E-Mail-Adresse "${trimmedEmail}" befinden sich Leerzeichen`);
                    } else if (!regex.test(trimmedEmail)) {
                        errorArr.push(`Bitte geben Sie bei der  E-Mail-Adresse "${trimmedEmail}" eine valide E-Mail-Adresse (z.b. test@typonauten.de) ein.`);
                    }
                }
            });
            if (errorArr.length > 0) {
                return errorArr;
            }
            return [];
        },
        checkFileUpload: function(value: string[], field: {validatorText:string}, model: any): string[] {
            if (value.length === 0) return ['Bitte laden Sie eine Datei hoch'];
            return [];
        },
        checkFileUploadDesigned : function (value:string, field, model:any) {
            if (!value) return ['Bitte laden Sie eine Datei hoch'];            
            return [];
        },
        checkFVisitor: function(value: string[], field: {validatorText:string}, model: any): string[] { 
            if(!value[0]) return ['Bitte geben Sie mindestens eine Begleitperson an.']
            return [];
        }, 
        checkFurtherJobs : function(value: string[], field: {validatorText:string}, model: any): string[] {
            const errorArr:string[] = [];
            value.forEach((element:any, index:number) => {
                if (element[0] === '') {
                    errorArr.push(`Bitte geben Sie im ${index+1}. Feld eine Sparte ein.`);
                }
                if (element[1] === '') {
                    errorArr.push(`Bitte geben Sie im ${index+1}. Feld einen Ausbildungsberuf ein.`);
                }
            });
            if (errorArr.length > 0) {
                return errorArr;
            }
            return [];
        } , 
        checkInput: function(value:string, field: {validatorText:string}, model: string): string[] {
            if (!value) {return [`Bitte geben Sie ${field.validatorText} ein.`];}
            return [];
        },
        checkMultiCheckBox: function(value:string[], field: {validatorText:string}, model: string): string[] {
            if (value.length === 0) {
                return [`Bitte wählen Sie mindestens ein Feld aus.`];
            }
            return [];
        },  
        checkPassword: function(value:string, field: {validatorText:string}, model: string): string[] {
            if (!value) {return [`Bitte geben Sie ein Passwort ein.`];}
            if (value.length < 8) {return [`Das Passwort ist zu kurz. Bitte mindestens 8 Zeichen verwenden.`];}
            if (!value.match(/[A-Z]{1,}/)) {return [`Das Passwort muss mindestens einen Großbuchstaben enthalten.`];}
            if (!value.match(/\W/)) {return [`Das Passwort muss mindestens ein Sonderzeichen enthalten.`];}
            return [];
        },
        checkPassword2: function(value:string, field: {validatorText:string}, model: {password: string, password2:string}): string[] {
            if (model.password !== model.password2) {return [`Die Passwörter stimmen nicht überein.`];}
            return [];
        },
        checkPLZ: function(value:string|null, field: {validatorText:string}, model: string): string[] {
            if (!value) {return [`Bitte geben Sie ${field.validatorText} ein.`];}
            let parsedPlz = parseInt(value);
            if (isNaN(parsedPlz)) {return [`Die Postleitzahl muss einen 5-stellige Zahl sein.`];}
            if (value.length !== 5) {return [`Eine Postleitzahl darf nicht mehr als 5 Zahlen beinhalten.`];}
            return [];
        },
        checkRadio: function(value:string|number|null, field: {validatorText:string, model:string}, model: string): string[] {
            if (!value) return [`Bitte klicken Sie ${field.validatorText} an.`];
            switch(field.model) {
                case 'tpsMedium':
                    if (value === null) {return [`Bitte wählen Sie aus, ob das Dokument eine TPS-Nummer hat oder nicht.`];}
                break;
                default: 
                    if (value === null) {return [`Bitte klicken Sie ${field.validatorText} an.`];}
                    if (value === 'null') {return [`Bitte klicken Sie ${field.validatorText} an.`];}
                    if (value === 0) {return [`Bitte klicken Sie ${field.validatorText} an.`];}
                    if (value === '') {return [`Bitte klicken Sie ${field.validatorText} an.`];}
            }
            return [];
        },
        checkRequestFile: function(value:string[], field: {validatorText:string, maxSize:number}, model: string): string[] {
            if (!value) return ['Bitte laden Sie eine Datei hoch'];   
            if (value.length > 0) {
                //check filetype
                let fileTypeArr = [
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    'application/pdf',
                    'application/vnd.openxmlformats-officedocument.presentationml.presentation'
                ];
                let file:any = value[0][0];
                if (fileTypeArr.indexOf(file.type) === -1) {
                    return ['Diese Datei hat nicht das erlaubte Dateiformat'];
                } 
    
                // //check filesize
                // if (file.size > calcInBytes(field.maxSize)) {return ['Die Datei ist zu groß'];}
            }
            return [];
        },
        checkSelect: function(value:any, field: {validatorText:string}, model: string): string[] {
            if (!value) {return [`Bitte wählen Sie ${field.validatorText} aus.`];}
            if (value === 0) {return [`Bitte wählen Sie ${field.validatorText} aus.`];}
            return [];
        },
        checkSelectJob: function(value: string[], field: {validatorText:string}, model: any): string[] {
            if (value.length === 0) {
                return ['Bitte suchen Sie mindestens einen Ausbildungsberuf aus'];
            }
            return [];
        }
    }

    return validators;
}
